import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://penichart.org";
const DEFAULT_IMG = `${SITE}/favicon.svg`;

export default function Seo({ title, description, path = "", image, type = "website", noindex = false, jsonLd }) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | PenichArt` : "PenichArt | Картини с маслени бои";
  const desc = description || "Оригинални ръчно рисувани картини с маслени и акрилни бои от художник Силва Пенева.";
  const img = image || DEFAULT_IMG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="PenichArt" />
      <meta property="og:locale" content="bg_BG" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
